/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// $(window).scroll(function(event){
// 	hasScrolled();
// });

// function hasScrolled() {
// 	let elem = document.getElementById("bigImageStickySection");
//   	if(!elem) return
//   	let stickyImageSelect = document.getElementById("stickyImageId");
// 	let top = elem.getBoundingClientRect().top;
//   	let bottom = elem.getBoundingClientRect().bottom;
//   	let stickyImageBottomValue = stickyImageSelect.getBoundingClientRect().bottom;

//   	if(top > 0){
//     	$('#bigImageStickySection').addClass('alignTop');
//     }else{
//     	$('#bigImageStickySection').removeClass('alignTop');
//     }

//     if(top < 130 && bottom > window.innerHeight - 80){
//       $('#bigImageStickySection').addClass('stick');
//     }else{
//       $('#bigImageStickySection').removeClass('stick');
//     }

// }

// function openSecondSlider(id){
//   $('.mobile_ddSlider_'+id).addClass('open');
// }
// function closeSecondSlide(){
//   $('#mobile_ddSlider_wrapperId.open').removeClass('open');
// }

$(document).ready(function () {
  $("body").on(
    "change",
    ".product-form__option-selector .has_extraopt",
    function () {
      window.location.href = $(this).find("option:selected").attr("data-href");
    }
  );

  $("body").on("click", ".toggle-menu,#close_mobile_menu", function (e) {
    e.preventDefault();
    $("body").toggleClass("panel-open");
  });

  $("body").on("click", ".headingContainer", function (e) {
    e.preventDefault();
    $(this)
      .closest(".mobileMenuTopItemsHeading")
      .find(".mobile_ddSlider_wrapper")
      .toggleClass("open");
  });

  $("body").on("click", ".goBack_ddSlider", function (e) {
    e.preventDefault();
    $(".mobile_ddSlider_wrapper").removeClass("open");
  });

  $(".bar_content_slider").slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow:
      "<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/2203/0177/files/left.png?v=1675078815' alt='Left arrow'></button>",
    nextArrow:
      "<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/2203/0177/files/next.png?v=1675078815' alt='Right arrow'></button>",
    autoplay: true,
    autoplaySpeed: 2000,
  });
    
  $(".leftImagesSlider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: false,
  });
  $(".custom-testimonial_content").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
  });

  $(".eb-wrap").slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 761,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });

  $(".logo_part ul").slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 761,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
        },
      },
    ],
  });
  $(".imagesCol").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: "unslick",
      },
    ],
  });

  $(".scroller .product-list__inner.has_slider").slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  // $(".filter_content_wp .filter_value_links").slick({
  //   slidesToShow: 3,
  //   slidesToScroll: 2,
  //   dots: false,
  //   arrows: false,
  //   adaptiveHeight: false,
  //   infinite: false
  // });

  $(".template-product .scroller .product-list__inner").slick({
    slidesToShow: 5,
    slidesToScroll: 5,
    dots: true,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  });

  function recll(){
    if($(".template-product product-recommendations .scroller .product-list__inner").length > 0){
      $(".template-product product-recommendations .scroller .product-list__inner").slick({
        slidesToShow: 5,
        slidesToScroll: 5,
        dots: true,
        arrows: true,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
            },
          },
        ],
      });   
    }else{
      setTimeout(function(){
        recll();
      },2000);
    }
  }
  recll();

  $(".product__thumbnail-list-inner").slick({
    slidesToShow: 8,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    focusOnSelect: true,
    vertical: true,
    verticalSwiping: true,
  });
  $(".ds-header").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    focusOnSelect: true,
    asNavFor: ".ds-content",
  });
  $(".ds-content").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    focusOnSelect: true,
    asNavFor: ".ds-header",
  });

  $('body').on('click','.facet-metabar-custom', function(){
    var __this = this;
    $(this).closest('.filter_content_wp').find('.product-facet__meta-bar-item[is="toggle-button"]').trigger('click');
    setTimeout(function(){
      $('#facet-filters').find('.product-facet__filter-list .collapsible-toggle[data-btnvalue="'+$(__this).attr('data-btnvalue')+'"]').trigger('click');
    },500);    
  });

  $("body").on("click", ".wellness-journal .wj-tabs-col", function () {
    var tabid = $(this).attr("id");
    $(this)
      .closest(".welness-journal-wrap")
      .find(".wj-tabs-col")
      .removeClass("active");
    $(this).addClass("active");
    $(this)
      .closest(".welness-journal-wrap")
      .find(".wj-tab-content")
      .removeClass("active");
    $(this)
      .closest(".welness-journal-wrap")
      .find('.wj-tab-content[data-src="' + tabid + '"]')
      .addClass("active");
  });

  $("body").on("change", ".wellness-journal .wellness_change", function () {
    var tabid = $(this).find(":selected").attr("id");
    $(this)
      .closest(".welness-journal-wrap")
      .find(".wj-tabs-col")
      .removeClass("active");
    $(this)
      .closest(".welness-journal-wrap")
      .find('.wj-tabs-col[id="' + tabid + '"]')
      .addClass("active");
    $(this)
      .closest(".welness-journal-wrap")
      .find(".wj-tab-content")
      .removeClass("active");
    $(this)
      .closest(".welness-journal-wrap")
      .find('.wj-tab-content[data-src="' + tabid + '"]')
      .addClass("active");
  });

  $("body").on(
    "click",
    "#facet-filters-form .product-facet__filter-item .collapsible-toggle",
    function () {
      $(this)
        .closest(".product-facet__filter-list")
        .find('button[aria-expanded="true"]')
        .not(this)
        .attr("aria-expanded", "false");
      $(this)
        .closest(".product-facet__filter-list")
        .find('button[aria-expanded="true"]')
        .not(this)
        .siblings("collapsible-content")
        .css("overflow", "visible");
    }
  );

  $("body").on("click", "cart-drawer .apercuRegular", function () {
    $(this)
      .closest(".apply-promocode-wrapper")
      .find(".cv-drawer-table")
      .slideToggle();
  });
  $("body").on("click", ".product__zoom-button", function () {
    $("body").addClass("enable-img-zoom");
  });
  $("body").on("click", ".pswp__button--close", function () {
    $("body").removeClass("enable-img-zoom");
  });

  $("body").on(
    "change",
    '.product-form .product-form__option-selector [name="letter_option4"]',
    function () {
      window.location.href = $(this).find("option:selected").attr("data-url");
    }
  );

  $("body").on("change", ".hardcover_picker .block-swatch__radio", function () {
    if ($(this).is(":checked")) {
      window.location.href = $(this).attr("data-link");
    }
  });

  $('body').on('click','.custom_filter_wp .checkbox-container input[type="checkbox"],.custom_outer_custom_filter input[type="checkbox"]',function(e){
    e.preventDefault();
    var _this = $(this);
    var href = $(this).attr('name');
    var val = $(this).attr('value');
    if(val != undefined && val != ''){
      if(val.indexOf(' ') >= 0){
        val = val.replaceAll(' ','+').replaceAll('&','%26');
      }
      if(val.indexOf('&') >= 0){
        val = val.replaceAll('&','%26');
      }
      var currentURL = window.location.href;
      var finalVAL = href+'='+val;
      var is_current = false;
      var without_cur = [];
      var params = {};
      var parser = document.createElement('a');
      parser.href = window.location.href;
      var query = parser.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');        
        if(encodeURI(href) == pair[0] && val == pair[1]){
          is_current = true;
        }else{
          if(_this.closest('.custom_filter_wp').hasClass('single_value')){
            if(encodeURI(href) == pair[0]){
             without_cur.push(pair[0] + '=' + val);    
            }else{
             without_cur.push(pair[0] + '=' + pair[1]);    
            }
          }else{
           without_cur.push(pair[0] + '=' + pair[1]); 
          }          
        }
      }
      if(is_current){               
        currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
        if(without_cur.length > 0){
          currentURL = currentURL + '?' +without_cur.join('&')
        }else{              
          currentURL = currentURL;
        }            
      }else{   
        if(_this.closest('.custom_filter_wp').hasClass('single_value') && currentURL.indexOf(href) > -1){
          var newurl = [];
          currentURL = (currentURL.indexOf('?') > -1) ? currentURL.split('?')[0] : currentURL;
          for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split('=');        
            if(encodeURI(href) == pair[0]){
              newurl.push(finalVAL);
            }else{                
              newurl.push(pair[0] + '=' + pair[1]);                 
            }
          }
          if(currentURL.indexOf('?') >= 0){
            currentURL = currentURL + '&' + newurl.join('&');
          }else{
            currentURL = currentURL + '?' + newurl.join('&');
          }
        }else{
         if(currentURL.indexOf('?') >= 0){
            currentURL = currentURL + '&' + finalVAL;
          }else{
            currentURL = currentURL + '?' + finalVAL;
          }  
        }        
      }         
      this.dispatchEvent(new CustomEvent("facet:criteria-changed", {
        bubbles: true,
        detail: {
          url: currentURL.toString()
        }
      }));
    }
  });
  
});
// $(document).bind('ready load scroll', function() {
//   var scroll = $(window).scrollTop();
//   if (scroll >= 150) {
//       $("body").addClass("scroll");
//   } else {
//       $("body").removeClass("scroll");
//   }
// });
$(document).on("click", 'a[href^="#"]', function (event) {
  event.preventDefault();

  $("html, body").animate(
    {
      scrollTop: $($.attr(this, "href")).offset().top - 140,
    },
    500
  );
});
